<template>
  <div class="conversation__message-input-panel">
    <div class="conversation__message-input-label-field">{{ localizeFieldName(message.fieldName) }}:</div>
    <div style="position: relative">

      <BaseInput
          v-model="input"
          name="message.fieldName"
          :maxLength="128"
          placeholder=""
          :type="message.fieldType"
          ref="InputField"
          required="true"
          :bordered="true"
      >
        <template v-slot:append>
<!--          <div v-if="fieldValues[el.name] === ''">-->
            <!-- show no icon when field is not required and field has no value -->
<!--          </div>-->
<!--          <div v-else-if="validateField(el,fieldValues[el.name])">-->
<!--            <CheckCircleIcon></CheckCircleIcon>-->
<!--          </div>-->
<!--          <div v-else>-->
<!--            <XCircleIcon></XCircleIcon>-->
<!--          </div>-->
        </template>

      </BaseInput>

<!--      <input ref="InputField" v-model="input" :type="message.fieldType === 'EMAIL' ? 'email' : 'text'" name="email" :aria-label="message.fieldName">-->
<!--      <button v-show="!message.body" @click="submit" aria-label="Submit" tabindex="0" class="conversation__message-input-submit-btn">-->
<!--        <svg focusable="false" aria-hidden="true" disabled="" class="">-->
<!--          <path d="M1.5 13.864L7.864 7.5 1.5 1.136" stroke-width="2.5" fill="none"-->
<!--                fill-rule="evenodd"></path>-->
<!--        </svg>-->
<!--      </button>-->
<!--      <svg v-show="message.body" focusable="false" aria-hidden="true" class="conversation__message-input-success">-->
<!--        <path d="M1 5.485l5.194 4.706L13.36.874" stroke-width="2.5" fill="none"-->
<!--              fill-rule="evenodd"></path>-->
<!--      </svg>-->
    </div>
  </div>
</template>

<script>
import ConversationService from "@/services/conversation.service";

export default {
  name: 'ConversationItemInput',
  props: [
      'message','focus'
  ],
  data() {
    return {
      input: ''
    }
  },
  computed: {
  },
  methods: {
    localizeFieldName(field) {
      if(field === 'EMAIL') {
        return this.$t('forms.email.label')
      } else {
        // field not found in localize map
        return field
      }
    },
    submit() {
      ConversationService.updateUserField(this.message.fieldType, this.message.fieldName, this.input)
    }
  },
  mounted() {
    if(this.focus) {
      this.$refs.InputField.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
  //
  // input message
  //

  .conversation__message-input-panel {
    position: relative;
    padding: 26px 24px 24px;
    text-align: left;
    background-color: var(--secondary-bg-color);
    border-radius: $default-border-radius-small;
    box-shadow: $default-box-shadow;

    .conversation__message-input-label-field {
      margin-bottom: 5px;
      font-size: $default-font-size;
      line-height: $default-line-height;
    }

    input[disabled] {
      cursor: not-allowed;
    }

    input {
      width: 100%;
      height: 40px;
      padding: 11px 40px 11px 16px;
      box-sizing: border-box;
      font-size: $default-font-size;
      border: 1px solid var(--color-background-grayer);
      color: var(--color);
      -webkit-text-fill-color: rgb(118, 118, 118);
      opacity: 1;
      background-color: var(--bg-color);
      border-radius: 5px;
      appearance: none;
    }

    button.conversation__message-input-submit-btn {
      cursor: pointer;
      position: absolute;
      top: 0px;
      right: 0px;
      bottom: 0px;
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
      //background-color: $primary-color;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      user-select: none;

      > svg {
        position: absolute;
        height: 15px;
        width: 10px;
        top: 12px;
        right: 14px;
        stroke: rgb(188, 188, 188);
      }
    }

    svg.conversation__message-input-success {
      position: absolute;
      height: 12px;
      width: 15px;
      top: 14px;
      right: 14px;
      stroke: rgb(57, 192, 137);
    }
  }
</style>
